const PrevIcon = () => {
  return (
    <img
      src={require("../../../assets/images/prev-icon.png")}
      alt="prev icon"
    />
  );
};

export default PrevIcon;
